<template>
  <div>
    <b-row>
      <b-col cols="5" class="mr-0">
        <vue-single-select
          :classes="{
            input: 'form-control',
            dropdown: 'dropdown p-0',
          }"
          v-model="selected"
          :options="companies"
          optionLabel="companyName"
        >
          <template slot="option" class="p-0" slot-scope="{ option }">
            <div class="">
              <!--             <span> {{ option.firstName }} {{ option.lastName }}</span>
 -->
              <span> {{ option.companyName }}</span>
            </div>
          </template>
        </vue-single-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { GET_ADDON_TYPE_COMPANIES } from "./actions";
import VueSingleSelect from "vue-single-select";

import { mapState } from "vuex";
export default {
  components: { VueSingleSelect },
  computed: {
    ...mapState({
      companies: (state) => state.superAdminStore.addonsAssign.companies.data,
    }),
  },
  watch: {
    selected(val) {
      if (val) {
        this.selected = val;
        this.$emit("company-select", val);
      }
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  created() {
    this.getCompanyAddon();
  },
  methods: {
    getCompanyAddon() {
      this.$store
        .dispatch(GET_ADDON_TYPE_COMPANIES, { addonTypes: 1, isSupplier: 1 })
        .then(() => {})
        .catch(() => {});
    },
    clearCompanySelect() {
      this.selected = null;
    },
    /*   onUserSelect(user) {
      this.$emit("user-select", user);
    }, */
  },
};
</script>

<style></style>
